import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const FlexBox = styled(Box)({
  display: 'flex',
  gap: '1rem',
  flexWrap: 'wrap',
});
